<template>
  <div class="apply-container">
    <h1>お申し込み内容</h1>
    <ItemTitle :text="plan" v-if="!isPublicStay" />
    <div class="content" v-if="!isPublicStay">
      <BoxViewMore>
        <span class="text-left m-0 p-0">■プラン名:</span>
        <span class="px-0" v-if="applicationDetail && applicationDetail.planNm">{{
          applicationDetail.planNm
        }}</span>
        <div class="ui pt-3" v-if="applicationDetail && applicationDetail.planLeadCopy">
          <p v-html="applicationDetail.planLeadCopy.replaceAll('\n', '<br>')"></p>
        </div>
      </BoxViewMore>
    </div>
    <div v-if="!isPublicStay && applicationDetail && applicationDetail.pointGrntNumAmt">
      <ItemTitle :text="destination" />
      <div class="py-5 pl-5">{{ applicationDetail.pointGrntNumAmt | formatInteger }}</div>
    </div>
    <div
      v-if="!isPublicStay && applicationDetail && applicationDetail.pointGrntNumAmt === 0"
    >
      <ItemTitle :text="destination" />
      <div class="py-5 pl-5">0</div>
    </div>

    <div class="expiryDate" v-if="applicationDetail">
      <div class="expiryDate">
        <div class="item-title" v-show="!isPublicStay">
          <span
            >テキストが入りますテキストが入ります
            テキストが入りますテキストが入りますテキストが入りますテキストが入りますテキストが入ります</span
          >
          <p>有効期限について</p>
        </div>
        <div></div>
      </div>
      <div class="table-info">
        <div class="item">
          <p>予約番号</p>
          <span v-if="acptNo">{{ acptNo }}</span>
        </div>
        <div class="item" v-if="applicationDetail && applicationDetail.fullName">
          <p>代表者名</p>
          <span>{{ applicationDetail.fullName }}</span>
        </div>
        <div class="item" v-if="applicationDetail && applicationDetail.acptDatetime">
          <p>受付日時</p>
          <span>{{ applicationDetail.acptDatetime }}</span>
        </div>
        <div class="item" v-if="applicationDetail && applicationDetail.billAmtTotal">
          <p>利用料金</p>
          <span>{{ applicationDetail.billAmtTotal | formatCurrency }}</span>
        </div>
        <div
          class="item"
          v-if="applicationDetail && applicationDetail.billAmtTotal === 0"
        >
          <p>利用料金</p>
          <span>0 円</span>
        </div>
        <div class="item">
          <p>お申し込み内容</p>
          <span></span>
        </div>
        <div class="item">
          <p>特典備考/注意事項</p>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemTitle from '../ItemTitle'
import BoxViewMore from '../BoxViewMore'
import moment from 'moment'

export default {
  components: {
    ItemTitle,
    BoxViewMore
  },
  props: ['value'],
  computed: {
    isPublicStay() {
      const { isPublicStay } = this.$route.query
      return isPublicStay === 'true'
    }
  },
  mounted() {
    const { acptNo } = this.$route.query
    this.acptNo = acptNo
    console.log('isPublicStay', this.isPublicStay)
  },
  created() {
    if (this.value) {
      this.applicationDetail = this.value
    }
  },
  watch: {
    value() {
      this.applicationDetail = this.value
    }
  },
  data() {
    return {
      applicationDetail: null,
      title: 'お申し込み内容',
      positionExpandLabel: 'Right',
      plan: 'プラン内容　',
      destination: 'ポイント交換先',
      acptNo: null,
      expiryDate: '有効期限',
      checkList: '確認事項'
    }
  },
  methods: {
    formatUseDate(date) {
      const useDate = date ? moment(date).format('YYYY/MM/DD') : ''
      return useDate
    },
    formatEndDate(date, night) {
      const start = moment(date)
      const end = start.add(night ? night : 1, 'days')
      const endDate = end ? moment(end).format('YYYY/MM/DD') : ''
      return endDate
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
